import { Spin } from 'antd';
import styles from './styles.module.scss';
import { LoadingOutlined } from '@ant-design/icons';

const Loading = () => {
  return (
    <Spin className={styles.spin_layout} indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
  );
};

export default Loading;
